import { render, staticRenderFns } from "./ClearanceApprovalChangeExpirationDialog.vue?vue&type=template&id=2aea5b7c&"
import script from "./ClearanceApprovalChangeExpirationDialog.vue?vue&type=script&lang=ts&"
export * from "./ClearanceApprovalChangeExpirationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
